import { render, staticRenderFns } from "./miniSeven.vue?vue&type=template&id=7046cf78&"
import script from "./miniSeven.vue?vue&type=script&lang=js&"
export * from "./miniSeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports